import { render, staticRenderFns } from "./CategoryProportionDetail.vue?vue&type=template&id=22381284&scoped=true"
import script from "./CategoryProportionDetail.vue?vue&type=script&lang=ts"
export * from "./CategoryProportionDetail.vue?vue&type=script&lang=ts"
import style0 from "./CategoryProportionDetail.vue?vue&type=style&index=0&id=22381284&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22381284",
  null
  
)

export default component.exports